import { useEffect, useRef, useState } from 'react'

interface UseTimerOptions {
  initialDuration?: number
  startImmediately?: boolean
}

export const useTimer = ({ initialDuration = 0, startImmediately = false }: UseTimerOptions) => {
  const [seconds, setSeconds] = useState(initialDuration)
  const [isActive, setIsActive] = useState(startImmediately && initialDuration > 0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  // Очистка интервала при размонтировании
  useEffect(
    () => () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    },
    []
  )

  // Запуск/остановка таймера
  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current)

    if (isActive && seconds > 0) {
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 1) {
            setIsActive(false)

            return 0
          }

          return prev - 1
        })
      }, 1000)
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [isActive, seconds > 0])

  const start = (duration?: number) => {
    if (duration !== undefined) setSeconds(duration)
    setIsActive(true)
  }

  const reset = (duration?: number) => {
    if (duration !== undefined) setSeconds(duration)
    setIsActive(false)
  }

  return { seconds, isActive, start, reset }
}
